import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetVendorsInputDto, VendorCreateDto, VendorDto, VendorExcelDownloadDto, VendorUpdateDto, VendorWithDetailsBatchCreateDto } from '../dtos/vendor/models';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  private restService = inject(RestService);
  apiName = 'Controlling';
  

  create = (input: VendorCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, VendorDto>({
      method: 'POST',
      url: '/api/controlling/vendors',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  createWithDetails = (input: VendorWithDetailsBatchCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/controlling/vendors/create-with-details',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/controlling/vendors/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/controlling/vendors',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, VendorDto>({
      method: 'GET',
      url: `/api/controlling/vendors/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/controlling/vendors/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetVendorsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<VendorDto>>({
      method: 'GET',
      url: '/api/controlling/vendors',
      params: { sapCode: input.sapCode, legalName: input.legalName, fantasyName: input.fantasyName, vatNumber: input.vatNumber, taxNumber: input.taxNumber, taxType: input.taxType, isSapDeleted: input.isSapDeleted, isGenericVendor: input.isGenericVendor, isOwnService: input.isOwnService, shouldAskForActivityReportAuthorization: input.shouldAskForActivityReportAuthorization, industryKey: input.industryKey, businessType: input.businessType, operationDgiId: input.operationDgiId, receptionAddress: input.receptionAddress, isDosesVendor: input.isDosesVendor, oldSapCode: input.oldSapCode, isMainVendor: input.isMainVendor, nameInitials: input.nameInitials, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: VendorExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/controlling/vendors/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, sapCode: input.sapCode, legalName: input.legalName, fantasyName: input.fantasyName, vatNumber: input.vatNumber, taxNumber: input.taxNumber, taxType: input.taxType, isSapDeleted: input.isSapDeleted, isGenericVendor: input.isGenericVendor, isOwnService: input.isOwnService, shouldAskForActivityReportAuthorization: input.shouldAskForActivityReportAuthorization, industryKey: input.industryKey, businessType: input.businessType, operationDgiId: input.operationDgiId, receptionAddress: input.receptionAddress, isDosesVendor: input.isDosesVendor, oldSapCode: input.oldSapCode, isMainVendor: input.isMainVendor, nameInitials: input.nameInitials, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, VendorDto[]>({
      method: 'GET',
      url: '/api/controlling/vendors/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: VendorUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, VendorDto>({
      method: 'PUT',
      url: `/api/controlling/vendors/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}